import { render, staticRenderFns } from "./VoucherPasses.vue?vue&type=template&id=1da10644&scoped=true&"
import script from "./VoucherPasses.vue?vue&type=script&lang=ts&"
export * from "./VoucherPasses.vue?vue&type=script&lang=ts&"
import style0 from "./VoucherPasses.vue?vue&type=style&index=0&id=1da10644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da10644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VFlex,VLayout,VRadio,VRadioGroup,VRow})
